module.exports = __webpack_public_path__ + "videos/34a2c78a8591ba09e1ddb593c4efeb51.mp4";